export default __webpack_public_path__ + "atomic/_patterns/01-atoms/navigation-image-map-pin/_navigation-image-map-pin.twig";